import React, { useCallback, useEffect, useState } from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import { Product } from "@shopify/hydrogen-react/storefront-api-types"

import { ProductStockSiblingSelectorButton } from "@app/components/Product/Stock/ProductStockSiblingSelectorButton"
import { ProductStockSiblingDropdown } from "@app/components/Product/Stock/ProductStockSiblingDropdown"

type Props = {
  product: Product
  setSelectedSiblingHandle: (handle: string) => void
  siblings: Array<GatsbyTypes.SanityProduct>
}

export const ProductStockSiblingSelector: React.FC<Props> = React.memo(({ product, setSelectedSiblingHandle, siblings }) => {
  const [activeSibling, setActiveSibling] = useState(null)

  const resetActiveSibling = useCallback(() => {
    setActiveSibling(siblings?.find(sibling => sibling?.shopify?.handle === product?.handle))
  }, [product?.handle, siblings])

  useEffect(() => {
    resetActiveSibling()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return siblings?.length > 5 ? (
    <Box width={["full", "50%"]}>
      <ProductStockSiblingDropdown activeSibling={activeSibling} siblings={siblings} setSelectedSiblingHandle={setSelectedSiblingHandle} />
    </Box>
  ) : siblings?.length > 1 ? (
    <Box width="full">
      <Text variant="text14" mb="16px" visibility={activeSibling?.colorTitle ? "visible" : "hidden"}>
        {activeSibling?.colorTitle || "-"}
      </Text>
      <Flex justifyContent="flex-start" alignItems="center" onMouseLeave={resetActiveSibling}>
        {siblings?.map(sibling => (
          <ProductStockSiblingSelectorButton
            key={sibling.id}
            activeSibling={activeSibling}
            handleMouseEnter={sibling => setActiveSibling(sibling)}
            setSelectedSiblingHandle={setSelectedSiblingHandle}
            sibling={sibling}
          />
        ))}
      </Flex>
    </Box>
  ) : null
})
